import { render, staticRenderFns } from "./ExtendOption.vue?vue&type=template&id=079cfc50&scoped=true&"
import script from "./ExtendOption.vue?vue&type=script&lang=js&"
export * from "./ExtendOption.vue?vue&type=script&lang=js&"
import style0 from "./ExtendOption.vue?vue&type=style&index=0&id=079cfc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079cfc50",
  null
  
)

export default component.exports